import { emailRequestSchema } from '@mfos/shared';
import { useMutation } from '@tanstack/react-query';
import { type SubmitEvent, useState } from 'react';
import { Link } from 'react-router';
import { ErrorNotice, SuccessNotice } from '../../components/ErrorNotice';
import { TextField } from '../../components/Field';
import { PublicLayout } from '../../components/PublicLayout';
import { requestPasswordReset } from './auth.api';
import { phrase } from '../../lib/i18n/runtime';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState<string | undefined>();
  const mutation = useMutation({ mutationFn: requestPasswordReset });

  function submit(event: SubmitEvent) {
    event.preventDefault();
    const parsed = emailRequestSchema.safeParse({ email });
    if (!parsed.success) {
      setEmailError('Enter a valid email address.');
      return;
    }
    setEmailError(undefined);
    mutation.mutate(parsed.data);
  }

  return (
    <PublicLayout title={phrase('Reset your password')}>
      {mutation.isSuccess ? (
        <>
          <SuccessNotice>
            {phrase(
              'If an account exists for that address, we sent a link to choose a new password.',
            )}
          </SuccessNotice>
          <Link to="/login">{phrase('Back to sign in')}</Link>
        </>
      ) : (
        <form onSubmit={submit} noValidate className="stack">
          <p>
            {phrase('Enter your account email and we will send you a link to set a new password.')}
          </p>
          <TextField
            label={phrase('Email')}
            type="email"
            autoComplete="email"
            value={email}
            onValueChange={setEmail}
            error={emailError}
            required
          />
          <ErrorNotice error={mutation.error} />
          <button type="submit" className="button" disabled={mutation.isPending}>
            {mutation.isPending ? phrase('Sending…') : phrase('Send reset link')}
          </button>
          <Link to="/login">{phrase('Back to sign in')}</Link>
        </form>
      )}
    </PublicLayout>
  );
}
